import { TableColumn } from './shared/table.constants';

export const COMPLECTS_COLUMNS: TableColumn[] = [
  { id: 'actions', title: '', className: 'w-1/12' },
  { id: 'id', title: 'id' },
  { id: 'name', title: 'name', className: 'last:text-left' },
];
